export default __webpack_public_path__ + "b6e9f537c358d7aff3dc08d68f12a0d4.png";